// extracted by mini-css-extract-plugin
module.exports = {"container":"i_BT","component":"i_BU","headline":"i_BV","title":"i_BW","subtitle":"i_BX","image":"i_BY","body":"i_BZ","column":"i_Ba"};